import { css } from "lit";
import constants from "../../constants";

export const style = css`
	* {
		box-sizing: border-box;
	}

	:host {
		display: flex;
		flex-direction: column;
		width: 100%;
		height: 100%;
		position: relative;
		overflow: hidden;
	}

	.head {
		min-height: 41px;
		flex: 0;
		display: flex;
		flex-direction: row;
		border-bottom: 1px solid var(--og-bucket-border-color);
	}

	.head > * {
		flex: 1;
		text-align: center;
		border-right: 1px solid var(--og-bucket-border-color);
		height: 100%;
	}

	.head > *:last-child {
		border-right: none;
	}

	.controls {
		flex: 0;
		padding: ${constants.FILTER_PADDING}px;
		display: flex;
		flex-direction: row;
	}

	.controls og-button {
		height: 22px;
		text-align: center;
		display: block;
		border-right: none;
		width: 20px;
	}

	.controls og-button.btn-primary {
		flex: 1;
	}

	.controls og-button.btn-secondary {
		flex: 0 0 19px;
		border-radius: 0;
	}

	.controls og-dropdown-menu {
		flex: 0 0 19px;
	}

	.body {
		flex: 1;
		overflow: hidden;
	}

	.body > og-container {
		height: 100%;
		overflow: hidden;
	}

	.controls og-button {
		min-width: 22px;
		border-top-right-radius: 0;
		border-bottom-right-radius: 0;
	}

	.controls og-button:last-child {
		border-top-right-radius: var(--og-base-radius);
		border-bottom-right-radius: var(--og-base-radius);
	}

	.controls og-dropdown-menu {
		border-top-left-radius: 0;
		border-bottom-left-radius: 0;
	}

	og-loader {
		height: 100%;
	}

	rp-multifiltercontainer {
		height: 100%;
	}

`;
